import {
    ExtendedConstructionNumber,
    ExtendedProjectPhase,
    ExtendedPropertyType,
    hasDatePassed,
} from '@bpd-library/utilities';
import { isNetherlands } from '@utilities/is-netherlands';

const isConstructionNumberAvailable = ({ status }: ExtendedConstructionNumber) =>
    status === 'Available' || status === 'InOption';

export const isProjectPhaseSubscribable = ({
    mainImage,
    status,
    propertyTypes,
    constructionNumbers: cns,
    customerJourneyMilestones: kcsMoments,
}: ExtendedProjectPhase) => {
    if (isNetherlands()) {
        if (status !== 'InPreparation' && status !== 'OnSale') return false;

        if (!mainImage?.url || !propertyTypes?.length) return false;

        if (status === 'InPreparation') {
            const newsArticle = kcsMoments?.find(({ type }) => type === 'NewPhaseAnnouncement');
            if (!newsArticle?.date || !hasDatePassed(newsArticle.date)) return false;
        } else if (status === 'OnSale') {
            if (cns?.length && !cns.some(isConstructionNumberAvailable)) return false;
        }

        return true;
    } else {
        if (status !== 'InPreparation' && status !== 'OnSale') return false;

        if (!mainImage?.url || !propertyTypes?.length) return false;

        if (status === 'OnSale') {
            if (cns?.length && !cns.some(isConstructionNumberAvailable)) return false;
        }

        return true;
    }
};

export const isPropertyTypeSubscribable = ({ mainImage }: ExtendedPropertyType) => !!mainImage;
